/**
 * One-shot "flash this conversation" signal.
 *
 * Set when the user clicks a "candidate replied" notification, consumed
 * once by the inbox when it opens that conversation. A module-level set
 * (not the URL) is what distinguishes a genuine notification click from
 * a plain refresh: a refresh still carries `?threadId=` in the URL but
 * starts a fresh JS context with an empty set, so it never flashes.
 *
 * Mirrors the `_flashStepIds` pattern used for the sequence-steps flash.
 */
const pending = new Set<string>();

/** Mark a conversation (thread or chat id) to flash on next open. */
export function markInboxFlash(id: string): void {
  if (!id) return;
  pending.add(id);
  // Auto-expire so an unconsumed flag (e.g. the user never lands on the
  // inbox) can't cause a stray flash much later.
  setTimeout(() => pending.delete(id), 10_000);
}

/** Consume the flash flag for a conversation. Returns true exactly once. */
export function consumeInboxFlash(id: string): boolean {
  if (!id || !pending.has(id)) return false;
  pending.delete(id);
  return true;
}
